// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1TnOV","content":"Consent_content__1A0Fc","footer":"Consent_footer__3B3lU"};